<template>
  <svg v-if="name" class="Icon" :class="'Icon--' + name">
    <title>{{ alt }}</title>
    <use :xlink:href="'/bundles/app/dist-configurator/icons.svg#icon-' + name"></use>
  </svg>
  <svg v-else class="Icon" :class="'Icon--' + name" aria-hidden="true">
    <use :xlink:href="'/bundles/app/dist-configurator/icons.svg#icon-' + name"></use>
  </svg>
</template>

<script>
export default {
  name: "Icon",
  props: {
    name: {
      type: String,
      default: "",
      required: false,
    },
    alt: {
      type: String,
      default: "",
      required: false,
    },
  },
  created () {
    var req = require.context("../../assets/icons/", true, /.*\.svg$/);
    req.keys().forEach(function (key) {
      req(key);
    });
    return req;
  },
};
</script>
